import { ISpace } from 'components/Space/types';

export const SAMOLET_PHONE = '+74956604141';
export const SAMOLET_PHONE_FORMATTED = '+7 (495) 660 41 41';

export const commonProps: ISpace = { align: 'center' };
